module.exports = {
          srcSet: __webpack_public_path__ + "b3909317159e7dc7778e52cc7aea5c54-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "b3909317159e7dc7778e52cc7aea5c54-1920.png",width: 1920,height: 869}],
          src: __webpack_public_path__ + "b3909317159e7dc7778e52cc7aea5c54-1920.png",
          toString:function(){return __webpack_public_path__ + "b3909317159e7dc7778e52cc7aea5c54-1920.png"},
          
          width: 1920,
          height: 869
        }